(() => {
  if (/\/collections\/all\/?$/.test(location.pathname)) {
    const catalogUrl = new URL(location.href);
    if (!catalogUrl.searchParams.has('sort_by') && !catalogUrl.searchParams.has('page') && ![...catalogUrl.searchParams.keys()].some(key => key.startsWith('filter.')) && !window.Shopify?.designMode) {
      catalogUrl.searchParams.set('sort_by', 'best-selling');
      location.replace(catalogUrl.href);
      return;
    }
  }
  const initialize = (root = document) => {
    root.querySelectorAll('[data-gift-campaign]').forEach(campaign => {
      if (campaign.dataset.initialized) return;
      campaign.dataset.initialized = 'true';
      const tabs = [...campaign.querySelectorAll('[data-gift-tab]')];
      const panels = [...campaign.querySelectorAll('[data-gift-panel]')];
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => { event.preventDefault(); select(tab); });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
        });
      });
      if (tabs.length) select(tabs[0]);
    });
    root.querySelectorAll('[data-famiily-sort]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.form.classList.add('famiily-catalog__form--enhanced');
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    root.querySelectorAll('.famiily-nav__group').forEach(group => {
      if (group.dataset.initialized) return;
      group.dataset.initialized = 'true';
      group.addEventListener('toggle', () => {
        if (group.open) document.querySelectorAll('.famiily-nav__group').forEach(other => { if (other !== group) other.open = false; });
      });
    });
    root.querySelectorAll('.famiily-filter-drawer').forEach(drawer => {
      if (drawer.dataset.initialized) return;
      drawer.dataset.initialized = 'true';
      const media = matchMedia('(min-width: 990px)');
      drawer.open = media.matches;
      media.addEventListener('change', event => { drawer.open = event.matches; });
    });
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('.famiily-nav__group')) document.querySelectorAll('.famiily-nav__group').forEach(group => { group.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.famiily-nav__group[open]').forEach(group => { group.open = false; group.querySelector('summary')?.focus(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
